"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionEnum = void 0;
var JourneyActionEnum;
(function (JourneyActionEnum) {
    JourneyActionEnum["StartVoiceInbound"] = "StartVoiceInbound";
    JourneyActionEnum["StartVoiceOutbound"] = "StartVoiceOutbound";
    JourneyActionEnum["VoiceAnswer"] = "VoiceAnswer";
    JourneyActionEnum["VoiceExternalDial"] = "VoiceExternalDial";
    JourneyActionEnum["VoiceGetDigits"] = "VoiceGetDigits";
    JourneyActionEnum["VoiceHangup"] = "VoiceHangup";
    JourneyActionEnum["VoiceInternalDial"] = "VoiceInternalDial";
    JourneyActionEnum["VoiceMenu"] = "VoiceMenu";
    JourneyActionEnum["VoicePlayback"] = "VoicePlayback";
    JourneyActionEnum["VoiceSayAlpha"] = "VoiceSayAlpha";
    JourneyActionEnum["VoiceSayDigits"] = "VoiceSayDigits";
    JourneyActionEnum["VoiceVariableSet"] = "VoiceVariableSet";
    JourneyActionEnum["VoiceSetLanguage"] = "VoiceSetLanguage";
    JourneyActionEnum["VoiceSayNumber"] = "VoiceSayNumber";
    JourneyActionEnum["VoiceSayPhonetic"] = "VoiceSayPhonetic";
    JourneyActionEnum["VoiceStartRecording"] = "VoiceStartRecording";
    JourneyActionEnum["VoiceStopRecording"] = "VoiceStopRecording";
    JourneyActionEnum["VoiceVoicemail"] = "VoiceVoicemail";
    JourneyActionEnum["StartMailInbound"] = "StartMailInbound";
    JourneyActionEnum["StartMailOutbound"] = "StartMailOutbound";
    JourneyActionEnum["StartForm"] = "StartForm";
    JourneyActionEnum["StartChat"] = "StartChat";
    JourneyActionEnum["OperationalHours"] = "OperationalHours";
    JourneyActionEnum["MailAutoResponse"] = "MailAutoResponse";
    JourneyActionEnum["ReplyLatestInboundMessage"] = "ReplyLatestInboundMessage";
    JourneyActionEnum["Queue"] = "Queue";
    JourneyActionEnum["Client"] = "Client";
    JourneyActionEnum["VoiceQueue"] = "VoiceQueue";
    JourneyActionEnum["UnAssign"] = "UnAssign";
    JourneyActionEnum["Agent"] = "Agent";
    JourneyActionEnum["Timeout"] = "Timeout";
    JourneyActionEnum["SetField"] = "SetField";
    JourneyActionEnum["RestRequest"] = "RestRequest";
    JourneyActionEnum["FetchContactData"] = "FetchContactData";
    JourneyActionEnum["EditConversation"] = "EditConversation";
    JourneyActionEnum["CloseConversation"] = "CloseConversation";
    JourneyActionEnum["AddInternalNote"] = "AddInternalNote";
    JourneyActionEnum["CloseTabs"] = "CloseTabs";
    JourneyActionEnum["SendMail"] = "SendMail";
    JourneyActionEnum["ForwardMail"] = "ForwardMail";
    JourneyActionEnum["Journey"] = "Journey";
    JourneyActionEnum["Rule"] = "Rule";
    JourneyActionEnum["RuleContact"] = "RuleContact";
    JourneyActionEnum["NoOp"] = "NoOp";
    JourneyActionEnum["When"] = "When";
    JourneyActionEnum["OpenBrowserTab"] = "OpenBrowserTab";
    JourneyActionEnum["SendTextMessage"] = "SendTextMessage";
})(JourneyActionEnum = exports.JourneyActionEnum || (exports.JourneyActionEnum = {}));
